import clsx from "clsx"

import type { FC, ReactNode } from "react"

import style from "./style.module.scss"

type ChildrenProps = {
  children: ReactNode
}

type WrapperProps = {
  title?: string
  filters?: ReactNode
  actionButton?: ReactNode
} & ChildrenProps

type HeaderProps = {
  columns: string[]
  className?: string
  firstColumn?: ReactNode
}

type ItemProps = {
  className?: string
  isActive?: boolean
  isClickable?: boolean
  onClick?: () => void
} & ChildrenProps

type ExtendedProps = {
  className?: string
  isVisible: boolean
} & ChildrenProps

type EmptyRowProps = {
  text?: string
}

const Wrapper: FC<WrapperProps> = ({ title, children, filters, actionButton }) => {
  return (
    <div className={style.wrapper}>
      {title && (
        <div className={style.wrapperTitle}>
          <span>{title}</span>
          {actionButton}
        </div>
      )}
      {filters && filters}
      <div className={style.wrapperContent}>{children}</div>
    </div>
  )
}

const Header: FC<HeaderProps> = ({ firstColumn, columns, className }) => {
  return (
    <div className={clsx(style.headerRow, className)}>
      {firstColumn}
      {columns.map(column => (
        <div key={column} className={style.row}>
          {column}
        </div>
      ))}
    </div>
  )
}

const Item: FC<ItemProps> = ({ children, className, isClickable, isActive, onClick }) => {
  return (
    <div
      className={clsx(style.itemRow, className, {
        [style.clickable]: isClickable,
        [style.active]: isActive
      })}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

const Extended: FC<ExtendedProps> = ({ children, className, isVisible }) => {
  if (!isVisible) return null

  return <div className={clsx(style.extendedRow, className)}>{children}</div>
}

const EmptyRow: FC<EmptyRowProps> = ({ text }) => {
  return <div className={style.emptyRow}>{text || "Нет данных"}</div>
}

const Table = {
  Wrapper,
  Header,
  Item,
  EmptyRow,
  Extended
}

export default Table
